// intro-overlay.js (session-based, homepage only)
document.addEventListener("DOMContentLoaded", function () {
  // nur auf Startseite
  if (window.location.pathname !== "/") return;

  // nur 1x pro Session (wenn Tab neu geöffnet wird, kommt es wieder)
  try {
    if (sessionStorage.getItem("haute_intro_played_session") === "1") return;
    sessionStorage.setItem("haute_intro_played_session", "1");
  } catch (e) {}

  const overlay = document.getElementById("hauteIntroOverlay");
  if (!overlay) return;

  const video = overlay.querySelector("video");
  const fadeMs = Number(overlay.getAttribute("data-fade-ms") || 700);
  const maxDurationMs = Number(overlay.getAttribute("data-max-duration-ms") || 4000);

  function finish() {
    overlay.classList.add("is-fading");
    if (video) {
      try { video.pause(); } catch (e) {}
    }
    setTimeout(() => {
      overlay.classList.remove("is-visible");
      overlay.style.display = "none";
    }, fadeMs + 50);
  }

  // anzeigen
  overlay.style.display = "block";
  overlay.classList.add("is-visible");

  if (video) {
    const p = video.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
    video.addEventListener("ended", finish, { once: true });
  }

  // fallback falls video nicht endet
  setTimeout(finish, maxDurationMs);
});